/* eslint-disable no-undef */
// Qualtrics Admin Wizard extracted from the ERB view for maintainability
let qualtricsWizardInitialized = false;

export function initQualtricsAdminWizard() {
  const form = $('.qualtrics-wizard-form');
  if (!form.length) return;

  // Prevent multiple initializations
  if (qualtricsWizardInitialized) return;
  qualtricsWizardInitialized = true;

  const embedUrlInput = $('#account_qualtrics_embed_url');
  const apiTokenInput = $('#account_qualtrics_api_token');

  const steps = {
    1: $('#step-1'),
    2: $('#step-2'),
    3: $('#step-3'),
    4: $('#step-4')
  };

  const step1Continue = $('#step-1-continue');
  const step2Verify = $('#step-2-verify');
  const step2Back = $('#step-2-back');
  const step3Save = $('#step-3-save');
  const step3Back = $('#step-3-back');
  const reconfigureBtn = $('#reconfigure-btn');
  const editFieldMappingBtn = $('#edit-field-mapping-btn');

  let currentStep = 1;

  // Parse embed URL to extract survey ID and subdomain
  function parseEmbedUrl(url) {
    if (!url) return {};
    const match = url.match(/^https:\/\/([^.]+)\.([^.]+)\.qualtrics\.com\/jfe\/form\/(SV_[a-zA-Z0-9]+)/);
    if (match) {
      return {
        subdomainPrefix: match[1],
        datacenter: match[2],
        surveyId: match[3]
      };
    }
    return {};
  }

  const embedUrlValue = $('#account_qualtrics_embed_url').val();
  const parsedUrl = parseEmbedUrl(embedUrlValue);

  const configurationState = {
    embedUrl: embedUrlValue,
    surveyId: parsedUrl.surveyId || null,
    subdomainPrefix: parsedUrl.subdomainPrefix || null,
    apiToken: apiTokenInput.val() ? 'true' : 'false',
    fieldMapping: (function () {
      try {
        const fieldMappingJson = form.data('field-mapping');
        return fieldMappingJson ? (typeof fieldMappingJson === 'string' ? JSON.parse(fieldMappingJson) : fieldMappingJson) : {};
      } catch (e) { return {}; }
    })()
  };

  // Get required fields from backend
  const requiredFields = (function () {
    try {
      const requiredFieldsJson = form.data('required-fields');
      return requiredFieldsJson ? (typeof requiredFieldsJson === 'string' ? JSON.parse(requiredFieldsJson) : requiredFieldsJson) : [];
    } catch (e) { return []; }
  })();

  function showStep(stepNumber) {
    Object.values(steps).forEach(step => step.addClass('d-none'));
    steps[stepNumber].removeClass('d-none');
    currentStep = stepNumber;
  }

  function initializeWizard() {
    const tokenPresentFlag = (
      apiTokenInput.data('tokenPresent') === true ||
      apiTokenInput.data('tokenPresent') === 'true' ||
      apiTokenInput.attr('data-token-present') === 'true' ||
      apiTokenInput.data('token_present') === true ||
      apiTokenInput.data('token_present') === 'true'
    );

    // Check if all required fields have mappings
    let requiredFieldsMapped = true;

    for (const fieldName of requiredFields) {
      if (!configurationState.fieldMapping[fieldName]) {
        requiredFieldsMapped = false;
        break;
      }
    }

    if (configurationState.surveyId && configurationState.subdomainPrefix &&
      (configurationState.apiToken === 'true' || tokenPresentFlag) &&
      requiredFieldsMapped) {
      showStep(4);
    } else if (configurationState.surveyId && configurationState.subdomainPrefix &&
      (configurationState.apiToken === 'true' || tokenPresentFlag)) {
      showStep(3);
      loadQuestions();
    } else if (configurationState.surveyId && configurationState.subdomainPrefix) {
      showStep(2);
    } else {
      showStep(1);
    }
  }

  function validateStep1() {
    const embedUrl = embedUrlInput.val();
    const isValid = embedUrl && embedUrl.match(/^https:\/\/[a-z0-9]+\.[a-z0-9]+\.qualtrics\.com\/jfe\/form\/SV_[a-zA-Z0-9]+$/);
    step1Continue.prop('disabled', !isValid);
    if (embedUrl && !embedUrl.match(/^https:\/\/[a-z0-9]+\.[a-z0-9]+\.qualtrics\.com\/jfe\/form\/SV_[a-zA-Z0-9]+$/)) {
      embedUrlInput.addClass('is-invalid');
    } else {
      embedUrlInput.removeClass('is-invalid');
    }
  }

  function validateStep2() {
    const apiToken = apiTokenInput.val();
    const isValid = apiToken && apiToken.trim().length > 0;
    step2Verify.prop('disabled', !isValid);
  }

  function validateStep3() {
    // Check all fields marked as required in the HTML
    let allRequiredFieldsHaveValues = true;

    $('.qualtrics-question-select[data-required-field="true"]').each(function () {
      const value = $(this).val();
      if (!value || value === '') {
        allRequiredFieldsHaveValues = false;
        return false; // break out of each loop
      }
    });

    step3Save.prop('disabled', !allRequiredFieldsHaveValues);
  }

  // Use namespaced events to prevent conflicts
  embedUrlInput.off('input.qualtricsWizard').on('input.qualtricsWizard', validateStep1);

  step1Continue.off('click.qualtricsWizard').on('click.qualtricsWizard', function () {
    const embedUrl = embedUrlInput.val();
    if (!embedUrl.match(/^https:\/\/[a-z0-9]+\.[a-z0-9]+\.qualtrics\.com\/jfe\/form\/SV_[a-zA-Z0-9]+$/)) {
      embedUrlInput.addClass('is-invalid');
      return;
    }

    // Update configuration state with parsed values
    const parsed = parseEmbedUrl(embedUrl);
    configurationState.embedUrl = embedUrl;
    configurationState.surveyId = parsed.surveyId || null;
    configurationState.subdomainPrefix = parsed.subdomainPrefix || null;

    showStep(2);
  });

  apiTokenInput.off('input.qualtricsWizard').on('input.qualtricsWizard', validateStep2);
  step2Back.off('click.qualtricsWizard').on('click.qualtricsWizard', function () { showStep(1); });

  step2Verify.off('click.qualtricsWizard').on('click.qualtricsWizard', function () {
    const btn = $(this);
    const originalText = btn.html();
    const apiToken = apiTokenInput.val();
    if (!apiToken) { apiTokenInput.addClass('is-invalid'); return; }
    btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin me-2"></i> Verifying...');
    $('#api-error-alert').addClass('d-none');
    $.ajax({
      url: form.data('verify-api-key-path'),
      method: 'POST',
      data: {
        authenticity_token: $('[name="authenticity_token"]').val(),
        api_token: apiToken,
        embed_url: configurationState.embedUrl
      },
      success: function (response) {
        if (response.success) {
          configurationState.apiToken = 'true';
          showStep(3);
          loadQuestions();
        } else {
          $('#api-error-message').text(response.error || 'Invalid API key');
          $('#api-error-alert').removeClass('d-none');
        }
      },
      error: function () {
        $('#api-error-message').text('Failed to verify API key. Please check your connection.');
        $('#api-error-alert').removeClass('d-none');
      },
      complete: function () {
        btn.prop('disabled', false).html(originalText);
        validateStep2();
      }
    });
  });

  $('.qualtrics-question-select').off('change.qualtricsWizard').on('change.qualtricsWizard', validateStep3);
  step3Back.off('click.qualtricsWizard').on('click.qualtricsWizard', function () {
    // If we have a complete configuration, go back to step 4, otherwise go to step 2
    if (configurationState.surveyId && configurationState.subdomainPrefix &&
      (configurationState.apiToken === 'true' || apiTokenInput.data('token_present') === true)) {
      showStep(4);
    } else {
      showStep(2);
    }
  });

  function loadQuestions() {
    const selects = $('.qualtrics-question-select');
    selects.prop('disabled', true);
    $.ajax({
      url: form.data('fetch-questions-path'),
      method: 'POST',
      data: {
        embed_url: configurationState.embedUrl,
        authenticity_token: $('[name="authenticity_token"]').val()
      },
      success: function (response) {
        if (response.success && response.questions) {
          const returnedIds = response.questions.map(function (q) { return q.id; });
          selects.each(function () {
            const select = $(this);
            const currentValue = select.val();
            // Remove all options except the first (placeholder)
            select.find('option:not(:first)').remove();

            $.each(response.questions, function (index, question) {
              const option = $('<option></option>').attr('value', question.id).text(question.id + ' - ' + question.text);
              select.append(option);
            });

            // Set the value after all options are added
            if (currentValue && returnedIds.indexOf(currentValue) === -1) {
              select.val('');
            } else if (currentValue) {
              select.val(currentValue);
            }
          });
          validateStep3();
        }
      },
      complete: function () { selects.prop('disabled', false); }
    });
  }

  form.off('submit.qualtricsWizard').on('submit.qualtricsWizard', function (e) {
    if (currentStep === 3) {
      e.preventDefault();
      const btn = step3Save;
      const originalText = btn.html();
      btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin me-2"></i> Saving...');
      $.ajax({
        url: form.attr('action'),
        method: 'POST',
        data: form.serialize(),
        success: function () {
          // Update the configuration state with new field mapping
          const formData = new FormData(form[0]);
          const fieldMapping = {};
          for (const [key, value] of formData.entries()) {
            if (key.startsWith('account[qualtrics_field_mapping][')) {
              const fieldName = key.match(/\[([^\]]+)\]$/)[1];
              fieldMapping[fieldName] = value;
            }
          }
          configurationState.fieldMapping = fieldMapping;
          showStep(4);
        },
        error: function () { alert('Failed to save field mapping. Please try again.'); },
        complete: function () { btn.prop('disabled', false).html(originalText); }
      });
    }
  });

  // Use namespaced events to prevent conflicts
  let reconfigureInProgress = false;
  reconfigureBtn.off('click.qualtricsWizard').on('click.qualtricsWizard', function (e) {
    e.preventDefault();
    // Don't use stopPropagation - it breaks Bootstrap dropdowns

    // Prevent multiple clicks
    if (reconfigureInProgress) return;
    reconfigureInProgress = true;

    if (confirm('Are you sure you want to reconfigure? This will reset your current settings.')) {
      showStep(1);
    }

    // Reset flag after a short delay
    setTimeout(() => {
      reconfigureInProgress = false;
    }, 500);
  });

  // Handle edit field mapping button
  editFieldMappingBtn.off('click.qualtricsWizard').on('click.qualtricsWizard', function (e) {
    e.preventDefault();
    showStep(3);
    loadQuestions();
  });

  validateStep1();
  validateStep2();
  validateStep3();
  initializeWizard();

  // Initialize additional page functionality
  initTestConnectionButton();
  initTestSurveyAccessButton();
  initSurveyToggle();

  // Cleanup on page unload to prevent memory leaks
  $(window).off('beforeunload.qualtricsWizard').on('beforeunload.qualtricsWizard', function () {
    // Remove all namespaced events
    form.find('*').off('.qualtricsWizard');
    $(window).off('.qualtricsWizard');
  });
}

// Test Connection button functionality
function initTestConnectionButton() {
  const testConnectionBtn = $('#test-connection-btn');
  if (!testConnectionBtn.length) return;

  testConnectionBtn.off('click.qualtricsWizard').on('click.qualtricsWizard', function () {
    const btn = $(this);
    const form = $('.qualtrics-wizard-form');
    const originalText = btn.html();

    btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin mr-2"></i>Testing...');

    $.ajax({
      url: form.data('verify-api-key-path'),
      method: 'POST',
      data: {
        api_token: form.data('test-connection-api-token'),
        survey_id: form.data('test-connection-survey-id'),
        authenticity_token: $('[name="authenticity_token"]').val()
      },
      success: function (response) {
        if (window.showToast) {
          window.showToast('success', 'Connection successful! API key and survey ID are valid.');
        }
      },
      error: function (xhr) {
        const response = xhr.responseJSON || {};
        const error = response.error || 'Connection failed. Please check your API token.';
        if (window.showToast) {
          window.showToast('danger', error);
        }
      },
      complete: function () {
        btn.prop('disabled', false).html(originalText);
      }
    });
  });
}

// Test Survey Access button functionality
function initTestSurveyAccessButton() {
  const testSurveyBtn = $('#test-survey-access-btn');
  if (!testSurveyBtn.length) return;

  testSurveyBtn.off('click.qualtricsWizard').on('click.qualtricsWizard', function () {
    const btn = $(this);
    const form = $('.qualtrics-wizard-form');
    const surveyUrl = form.data('survey-url');

    if (!surveyUrl) {
      if (window.showToast) {
        window.showToast('warning', 'No survey URL configured. Please save settings first.');
      }
      return;
    }

    // Try multiple methods to open the URL to work around browser security
    try {
      // Method 1: Use an anchor tag with proper attributes
      const link = document.createElement('a');
      link.href = surveyUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      if (window.showToast) {
        window.showToast('info', 'Survey opened in a new tab. Check if it loads without errors.');
      }
    } catch (e) {
      console.error('Failed to open survey via link:', e);
      // Fallback to window.open
      const testWindow = window.open(surveyUrl, '_blank', 'noopener,noreferrer');

      if (testWindow) {
        if (window.showToast) {
          window.showToast('info', 'Survey opened in a new tab. Check if it loads without errors.');
        }
      } else {
        if (window.showToast) {
          window.showToast('warning', 'Pop-up blocked. Please allow pop-ups to test the survey.');
        }
      }
    }
  });
}

// Survey toggle auto-save functionality
function initSurveyToggle() {
  const surveyToggle = $('#survey-toggle');
  if (!surveyToggle.length) return;

  surveyToggle.off('change.qualtricsWizard').on('change.qualtricsWizard', function () {
    const toggle = $(this);
    const isChecked = toggle.is(':checked');
    const form = toggle.closest('form');

    $.ajax({
      url: form.attr('action'),
      method: 'POST',
      data: form.serialize(),
      success: function (response) {
        if (window.showToast) {
          const message = isChecked ?
            'Applications enabled! Users can now submit through Qualtrics.' :
            'Applications disabled. Users will see a "not accepting applications" message.';
          window.showToast('success', message);
        }
      },
      error: function () {
        // Revert toggle on error
        toggle.prop('checked', !isChecked);
        if (window.showToast) {
          window.showToast('danger', 'Failed to update setting. Please try again.');
        }
      }
    });
  });
}

// Only auto-execute in non-test environments
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
  $(document).ready(function () {
    initQualtricsAdminWizard();
  });
}


